import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { Activity } from "lucide-react";

export default function LoginsChart({ data }) {
  const total = data.reduce((s, d) => s + d.count, 0);
  const max = data.reduce((m, d) => Math.max(m, d.count), 0);
  const avg = data.length > 0 ? Math.round(total / data.length) : 0;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Activity size={16} className="text-gray-500" />
          <h3 className="text-sm font-semibold text-gray-900">
            Logins últimos 30 días
          </h3>
        </div>
        <div className="flex items-center gap-4 text-xs text-gray-500">
          <span>
            Total: <strong className="text-gray-900">{total}</strong>
          </span>
          <span>
            Media/día: <strong className="text-gray-900">{avg}</strong>
          </span>
          <span>
            Pico: <strong className="text-gray-900">{max}</strong>
          </span>
        </div>
      </div>

      {total === 0 ? (
        <div className="h-48 flex items-center justify-center text-sm text-gray-400">
          Sin logins en los últimos 30 días
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={220}>
          <LineChart
            data={data}
            margin={{ top: 5, right: 10, left: -20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
            <XAxis
              dataKey="label"
              tick={{ fontSize: 10 }}
              interval="preserveStartEnd"
            />
            <YAxis tick={{ fontSize: 10 }} allowDecimals={false} />
            <Tooltip
              contentStyle={{ fontSize: 12, borderRadius: 8 }}
              formatter={(value) => [`${value} logins`, "Logins"]}
            />
            <Line
              type="monotone"
              dataKey="count"
              stroke="#06b6d4"
              strokeWidth={2}
              dot={{ r: 2 }}
              activeDot={{ r: 5 }}
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
